import * as React from 'react';
import { DirectionalHint, ITooltipProps, TooltipHost } from '@fluentui/react';
import {
    GroupedComboBoxOnRenderTooltip,
    GroupedComboBoxOnRenderTooltipProps,
    isFunction,
} from 'grouped-combobox-core';

const tooltipProps: ITooltipProps = {
    calloutProps: { styles: { calloutMain: { whiteSpace: 'pre-line' } } },
};

/**
 * Wrap the specified component inside a TooltipHost if the tooltip is not empty.
 */
export const RenderTooltip: GroupedComboBoxOnRenderTooltip = (
    props: GroupedComboBoxOnRenderTooltipProps
): React.ReactElement => {
    const { targetElement, tooltip, showTooltipOnRight, mainContent, hostClassName, tooltipHost } =
        props;

    const tooltipText = isFunction(tooltip) ? tooltip() : tooltip;

    return (
        <TooltipHost
            componentRef={tooltipHost}
            content={tooltipText}
            directionalHint={
                showTooltipOnRight ? DirectionalHint.rightCenter : DirectionalHint.leftCenter
            }
            directionalHintForRTL={
                showTooltipOnRight ? DirectionalHint.leftCenter : DirectionalHint.rightCenter
            }
            calloutProps={
                targetElement
                    ? {
                          target: targetElement,
                      }
                    : undefined
            }
            tooltipProps={tooltipProps}
            hostClassName={hostClassName}
        >
            {mainContent}
        </TooltipHost>
    );
};
